(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ask-question-share"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqsInitialized) return;
    window.__aqsInitialized = true;

    function openDialog(dialog) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      dialog.close();
      document.documentElement.style.overflow = '';
    }

    // ---- Guard against the nested "Contact form" block closing our
    // <dialog> on an invalid submission.
    //
    // Root cause: a <form method="dialog"> that lives inside a native
    // <dialog> closes that dialog THE INSTANT it's submitted - that's
    // the browser's built-in behavior for that method value, and it
    // fires regardless of whether the field values are valid. If the
    // theme's own validation script only calls preventDefault()
    // asynchronously (e.g. after an AJAX check), the dialog's native
    // close can win the race even though the error message did
    // render - which matches "error shows, then it closes anyway."
    // The following two pieces stop that from ever happening, without
    // touching the contact-form block's own markup or JS at all.
    function neutralizeDialogFormSubmit(dialog) {
      if (!dialog) return;
      var forms = dialog.querySelectorAll('form');
      forms.forEach(function (form) {
        if (form.getAttribute('method') === 'dialog') {
          form.setAttribute('method', 'post');
        }
      });
    }

    document.querySelectorAll('.aqs-modal').forEach(neutralizeDialogFormSubmit);

    // Safety net: independently re-check validity on submit so the
    // popup can never proceed/close on bad data, even if the theme's
    // own validator is slow, disabled, or races the native close.
    //
    // For a VALID submission, we go one step further: the theme's
    // contact form is a normal <form> that performs a real browser
    // submission (POST) on success. That's a full page navigation -
    // which is what makes the popup "auto close" even with no close
    // logic of our own involved, since the whole page (and therefore
    // the dialog) gets torn down and reloaded. To stop that, we
    // intercept the submit ourselves and send it via fetch() instead,
    // so the browser never navigates and the dialog simply stays open
    // the whole time, with its own inline success/error message.
    function showFormStatus(dialog, kind, message) {
      var body = dialog.querySelector('.aqs-modal__body');
      if (!body) return;
      var existing = body.querySelector('.aqs-form-status');
      if (existing) existing.remove();

      var status = document.createElement('div');
      status.className = 'aqs-form-status aqs-form-status--' + kind;
      status.innerHTML =
        (kind === 'success'
          ? '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="currentColor"/><path d="M12 7v6M12 16.5v.01" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>') +
        '<span>' + message + '</span>';
      body.insertBefore(status, body.firstChild);
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        var dialog = form.closest('.aqs-modal');
        if (!dialog) return;

        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
          return;
        }

        // Valid: stop the native navigation and submit via fetch so
        // the dialog can never be torn down by a page reload.
        event.preventDefault();

        var submitControl = form.querySelector('button[type="submit"], input[type="submit"]');
        var originalLabel = submitControl ? submitControl.innerHTML || submitControl.value : '';
        if (submitControl) {
          submitControl.disabled = true;
          if ('value' in submitControl && submitControl.tagName === 'INPUT') {
            submitControl.value = 'Sending...';
          } else {
            submitControl.textContent = 'Sending...';
          }
        }

        var formData = new FormData(form);
        var actionUrl = form.getAttribute('action') || window.location.pathname;

        fetch(actionUrl, {
          method: (form.getAttribute('method') || 'POST').toUpperCase(),
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            showFormStatus(
              dialog,
              'success',
              "Thanks for contacting us. We'll get back to you as soon as possible."
            );
            form.reset();
          })
          .catch(function () {
            showFormStatus(
              dialog,
              'error',
              'Something went wrong sending your message. Please try again.'
            );
          })
          .finally(function () {
            if (submitControl) {
              submitControl.disabled = false;
              if ('value' in submitControl && submitControl.tagName === 'INPUT') {
                submitControl.value = originalLabel;
              } else {
                submitControl.textContent = originalLabel;
              }
            }
          });
      },
      true
    );

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-aqs-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-aqs-open'));
        openDialog(dialog);
        return;
      }

      var closer = event.target.closest('[data-aqs-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      var copyButton = event.target.closest('[data-aqs-copy-button]');
      if (copyButton) {
        var wrapper = copyButton.closest('.aqs-copy');
        var input = wrapper && wrapper.querySelector('[data-aqs-copy-input]');
        if (!input) return;

        var finish = function () {
          var label = copyButton.querySelector('[data-aqs-copy-label]');
          var original = label ? label.textContent : '';
          var copiedLabel = copyButton.getAttribute('data-copied-label') || 'Copied!';
          copyButton.classList.add('is-copied');
          if (label) label.textContent = copiedLabel;
          setTimeout(function () {
            copyButton.classList.remove('is-copied');
            if (label) label.textContent = original;
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(input.value).then(finish).catch(function () {
            input.select();
            document.execCommand('copy');
            finish();
          });
        } else {
          input.select();
          document.execCommand('copy');
          finish();
        }
        return;
      }

      // Clicking the dialog backdrop (the <dialog> element itself, not
      // its inner panel) closes the modal.
      if (event.target.tagName === 'DIALOG' && event.target.classList.contains('aqs-modal')) {
        closeDialog(event.target);
      }
    });

    document.addEventListener('close', function (event) {
      if (event.target.matches && event.target.matches('.aqs-modal')) {
        document.documentElement.style.overflow = '';
      }
    }, true);

    document.addEventListener('cancel', function (event) {
      if (event.target.matches && event.target.matches('.aqs-modal')) {
        document.documentElement.style.overflow = '';
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
